import { cn } from "~/utils";
import { Icon, IconSizes } from "./icon";

interface ErrorIconProps extends React.ComponentProps<"div"> {
  className?: string;
  iconSize?: IconSizes;
  pulse?: boolean;
}

export const Error = ({
  className,
  iconSize = "large",
  pulse = true,
  ...props
}: ErrorIconProps) => {
  return (
    <div
      className={cn(
        "relative rounded-full flex p-2.5 justify-center items-center bg-icon-error-background",
        !pulse && "ring-4 ring-system-error/5",
        pulse && "p-4",
        className,
      )}
      {...props}
    >
      {pulse && (
        <div className="absolute inset-0 bg-system-error/25 rounded-full animate-ping duration-2000" />
      )}

      <Icon
        className="absolute"
        name="octagon-alert"
        size={iconSize}
        iconClassName="h-full w-full text-system-error"
      />
    </div>
  );
};
